// Which concepts the reader has ticked off, kept in this browser only.
// Keys are "topicId:concept text", so reordering concepts keeps progress.
import { useCallback, useState } from "react";

const KEY = "mek-progress";

const load = (): Set<string> => {
  try {
    const raw = localStorage.getItem(KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
};

export const conceptKey = (topicId: string, concept: string) => `${topicId}:${concept}`;

export function useProgress() {
  const [done, setDone] = useState<Set<string>>(load);

  const toggle = useCallback((key: string) => {
    setDone((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      try {
        localStorage.setItem(KEY, JSON.stringify(Array.from(next)));
      } catch {
        // storage blocked: progress lasts for this visit only
      }
      return next;
    });
  }, []);

  return { done, toggle };
}
